import React, { useMemo } from 'react';
import { Icon } from '@oneaudi/unified-web-components';
import mapContext from '../../../contexts/map-context';
import { Dealer } from '../../../models/dealer';
import { MapMarkerDealerIconContainer, MapMarkerDefaultIcon } from './MapMarker.styled';

export type Props = {
  dealer: Dealer;
};

const iconHeirachy = [
  {
    component: <Icon size="s" name="administrator" data-testid="map-marker-icon-service" />,
    service: 'service',
  },
  {
    component: <Icon size="s" name="shopping-basket" data-testid="map-marker-icon-sales" />,
    service: 'sales',
  },
  {
    component: <Icon size="s" name="car" data-testid="map-marker-icon-etron" />,
    service: 'etron',
  },
  {
    component: <Icon size="s" name="used-cars" data-testid="map-marker-icon-used-cars" />,
    service: 'usedcars',
  },
  {
    component: <Icon size="s" name="top-speed" data-testid="map-marker-icon-audi-sport" />,
    service: 'sales-r8',
  },
  {
    component: <Icon size="s" name="top-speed" data-testid="map-marker-icon-audi-sport" />,
    service: 'service-r8',
  },
  {
    component: <Icon size="s" name="car" data-testid="map-marker-icon-silver-car" />,
    service: 'silver-car-by-audi',
  },
  {
    component: <Icon size="s" name="caution" data-testid="map-marker-icon-accident-specialist" />,
    service: 'accident-specialist',
  },
  {
    component: <Icon size="s" name="poi-car" data-testid="map-marker-icon-audi-on-demand" />,
    service: 'audi-on-demand',
  },
];

export const MapMarkerDealerIcon = ({ dealer }: Props) => {
  const { userSelectedFilters, connectedDealer } = mapContext.useMapState();
  const isConnected = connectedDealer === dealer.dealerId;
  const addressForDisplay = dealer.address.join();

  const foundMapMarkerDealerIcon = useMemo(
    () =>
      iconHeirachy.find(
        (icon) =>
          userSelectedFilters.includes(icon.service) && dealer.services.includes(icon.service),
      ),
    [userSelectedFilters],
  );

  return (
    <MapMarkerDealerIconContainer
      data-testid="map-marker-icon"
      role="button"
      tabIndex={0}
      aria-label={`${dealer.name} ${addressForDisplay}`}
    >
      {foundMapMarkerDealerIcon ? (
        foundMapMarkerDealerIcon.component
      ) : (
        <>
          {isConnected && <Icon size="s" name="poi-active" className="poi-icon-connected" />}
          <MapMarkerDefaultIcon data-testid="map-marker-icon-default" />
        </>
      )}
    </MapMarkerDealerIconContainer>
  );
};
